<template>
  <div v-if="files">
    <files-list :files="files" @remove="remove" />

    <modal
      :show="isModalShow"
      :dark="true"
      :outside="false"
      @close="closeModal"
    >
      <add-files @close="closeModal" @uploadFiles="uploadFiles" />
    </modal>

    <button
      :disabled="!$guard('write', 'Masters')"
      class="main-button mt20"
      @click="openModal"
    >
      {{ $t("global.add") }}
    </button>
  </div>
</template>

<script>
import addFiles from '@/components/modals/files/addFiles'
import filesList from '@/components/lists/files/filesList'

import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
    name: 'filesView',
    props: ['dataUser'],
    components: {
        addFiles,
        filesList,
    },
    data() {
        return {
            isModalShow: false,
            entity_type: 'master',
        }
    },
    computed: {
        ...mapGetters({
            files: 'files/files',
        }),
    },
    methods: {
        ...mapMutations({
            clear: 'files/clear',
        }),
        ...mapActions({
            addFiles: 'files/add',
            fetch: 'files/fetch',
            removeFile: 'files/remove',
        }),
        closeModal() {
            this.isModalShow = false
        },
        openModal() {
            this.isModalShow = true
        },
        prepareForm(files) {
            const fd = new FormData()
            files.forEach((file) => {
                fd.append('files[]', file)
            })
            fd.append('entity_type', this.entity_type)
            fd.append('entity_id', this.dataUser.id)

            return fd
        },
        async uploadFiles(files) {
            const isOkey = await this.addFiles(this.prepareForm(files))
            if (!isOkey) return

            this.closeModal()
            this.getFiles()
        },
        getFiles() {
            this.fetch({
                entity_type: this.entity_type,
                entity_id: this.dataUser.id,
            })
        },
        async remove(id) {
            await this.removeFile(id)
            this.getFiles()
        },
    },
    mounted() {
        this.getFiles()
    },
    beforeDestroy() {
        this.clear()
    },
}
</script>
